export const CHART_BRUSH_SIZES = {
  BRUSH_HEIGHT: 10,
  BRUSH_STROKE_WIDTH: 1,
};

export const DEFAULT_CHART_MAX_BRUSH_DATA_POINTS = 50;
